import React from 'react';
import Conditional from "../Hooks/ConditionalRender";
import * as style from '../Hooks/style';

//Images
import laptopBG from '../Images/robot/laptopBG.png';
import bubble1 from '../Images/robot/bubble1.png';
import bubble2 from '../Images/robot/bubble2.png';
import bubble3 from '../Images/robot/bubble3.png';
import bubble4 from '../Images/robot/bubble4.png';
import square1 from '../Images/robot/square1.png';
import square2 from '../Images/robot/square2.png';
import square3 from '../Images/robot/square3.png';
import square4 from '../Images/robot/square4.png';
import robot from '../Images/robot/robot.png';
import beam from '../Images/robot/beam.png';
import ray1 from '../Images/robot/ray1.png';
import ray2 from '../Images/robot/ray2.png';
import ray3 from '../Images/robot/ray3.png';

export const Sect5 = ({fref, active5}) => {
  return (
    <style.Section5 ref={fref}>
      <Conditional if={active5 === true}>
        <section>
          <p>Don't Miss Your Opportunity To Power-up Your Maritime Business</p>
          <p>Make The Switch Now</p>
          <button>
            &nbsp;
            <a href="mailto:marinax.sg@gmail.com" className="button">
              Get In Touch &nbsp;&nbsp;→
            </a>
            &nbsp;
          </button>
        </section>
        <section className="robotcontainer">
          <img className="laptopBG" src={laptopBG} alt="laptopBG" />
          <img className="robot" src={robot} alt="robot" />
          <img className="beam" src={beam} alt="beam" />
          <img className="ray1" src={ray1} alt="ray1" />
          <img className="ray2" src={ray2} alt="ray2" />
          <img className="ray3" src={ray3} alt="ray3" />
          <img className="square1" src={square1} alt="square1" />
          <img className="square2" src={square2} alt="square2" />
          <img className="square3" src={square3} alt="square3" />
          <img className="square4" src={square4} alt="square4" />
          <span className="bubble1box">
            <img className="bubble1" src={bubble1} alt="bubble1" />
          </span>
          <span className="bubble2box">
            <img className="bubble2" src={bubble2} alt="bubble2" />
          </span>
          <span className="bubble3box">
            <img className="bubble3" src={bubble3} alt="bubble3" />
          </span>
          <span className="bubble4box">
            <img className="bubble4" src={bubble4} alt="bubble4" />
          </span>
        </section>
        <style.styledWaves>
          <style.Waves />
        </style.styledWaves>
      </Conditional>
    </style.Section5>
  );
}